import { createFileRoute } from '@tanstack/react-router';
import { StudioLayout } from '../../features/studio/layout.tsx';

/** `/studio/*`: the agent studio (ADR-013, a workbench feature since 13). Code-split by `autoCodeSplitting`. */
export const Route = createFileRoute('/_app/studio')({ component: StudioLayout });
